module.exports = __webpack_public_path__ + "img/38.7.Chla.d6566b5f.png";